// extracted by mini-css-extract-plugin
export default {"title":"Sr3Il","content":"Rf6eX","row":"NTPP5","paragraph":"iyOUD","item":"iTmN3"};